import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined;

const maybeSupabase = url && key ? createClient(url, key, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
}) : null;

// Runtime availability is still represented by supabaseConfigured. Keeping the
// exported client type non-null prevents TypeScript from losing a prior runtime
// guard inside nested async callbacks (for example signed-URL mapping).
export const supabase = maybeSupabase as NonNullable<typeof maybeSupabase>;
export const supabaseConfigured = Boolean(maybeSupabase);
